import { Skeleton } from "@shared/src/components/ui/skeleton";

function MobileViewSkeleton() {
  return (
    <div className="md:hidden flex flex-col h-full py-10">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div className="w-10 h-10" />
        <Skeleton className="h-8 w-36" />
        <div className="w-10 h-10" />
      </div>

      {/* Content */}
      <div className="flex flex-col gap-4 items-center flex-1 justify-center">
        {/* Social Login Section */}
        <div className="w-full space-y-4 px-4">
          <Skeleton className="h-5 w-28 mx-auto" />
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {[1, 2, 3, 4].map(i => (
              <Skeleton key={i} className="h-[56px] rounded-xl" />
            ))}
          </div>
        </div>

        {/* Wallets Section */}
        <div className="w-full space-y-4">
          <Skeleton className="h-5 w-24 mx-auto" />
          <div className="flex gap-3 items-center justify-center">
            {[1, 2, 3, 4].map(i => (
              <Skeleton key={i} className="w-[56px] h-[56px] rounded-xl" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function DesktopViewSkeleton() {
  return (
    <div className="hidden md:flex">
      {/* Left Side */}
      <div className="w-[45%] px-4 flex flex-col py-10">
        <Skeleton className="h-8 w-32 mb-6" />
        <Skeleton className="h-5 w-40 mb-6" />

        <div className="space-y-3">
          {/* Social Login Button */}
          <Skeleton className="w-full h-[72px] rounded-2xl" />

          {/* Popular Wallets */}
          {[1, 2, 3, 4].map(i => (
            <Skeleton key={i} className="w-full h-[72px] rounded-2xl" />
          ))}
        </div>
      </div>

      {/* Right Side */}
      <div className="w-[55%] border-l border-border-tertiary rounded-l-5xl pl-6 relative">
        <div className="py-10">
          <div className="flex justify-between items-center mb-6">
            <div />
            <Skeleton className="h-8 w-32" />
            <div className="w-10 h-10" />
          </div>

          <div className="flex flex-col items-center justify-center gap-4">
            <Skeleton className="w-[240px] h-[240px] rounded-2xl" />
            <Skeleton className="w-32 h-5" />
            <Skeleton className="w-48 h-4" />
            <Skeleton className="w-[200px] h-[48px] rounded-full mt-4" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function SignInModalSkeleton() {
  return (
    <>
      <MobileViewSkeleton />
      <DesktopViewSkeleton />
    </>
  );
}
